import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';

type ConfirmRemindersModalProps = {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmRemindersModal = (props: ConfirmRemindersModalProps) => {
  const { isOpen, isLoading, onClose, onConfirm } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small">
      <Modal.Header title="Send awaiting-invoice reminders?" className="text-center" />
      <Modal.Body className="flex flex-col justify-center items-center overflow-x-hidden mb-6 text-xs leading-5">
        <p>
          This will email every mentor who currently has an activity report awaiting invoice for the
          selected month.
        </p>
      </Modal.Body>
      <Modal.Footer className="flex justify-center gap-4">
        <Button
          className="h-6 min-h-6"
          size="large"
          variant="secondary"
          buttonText="Take me back"
          onClick={onClose}
        />
        <Button
          className="h-6 min-h-6"
          size="large"
          variant="primary"
          buttonText="Send reminders"
          isLoading={isLoading}
          onClick={onConfirm}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmRemindersModal;
